<template>
  <button type="button" class="close close-sidebar" :aria-label="ariaLabel" @click="closeSidebar()">
    <svg class="icon">
      <title>{{ title }}</title>
      <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#close-icon"></use>
    </svg>
  </button>
</template>

<script>
export default {
  name: 'closesidebar',
  props: {
    title: { type: String, default: 'Close Sidebar' },
    ariaLabel: {
      type: String,
      default: '',
    },
  },
  methods: {
    closeSidebar() {
      if (window.eventBus) {
        window.eventBus.$emit('sidebar.toggled', false);
      }
    },
  },
};
</script>
